import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getCampaignsWithCounts } from "../slices/thunks";

const Navdata = () => {
    const history = useNavigate();

    //state data
    const [isDashboard, setIsDashboard] = useState(false);
    const [isUsers, setIsUsers] = useState(false);
    const [isAuth, setIsAuth] = useState(false);
    const [isPages, setIsPages] = useState(false);
    const [isBaseUi, setIsBaseUi] = useState(false);
    const [isAdvanceUi, setIsAdvanceUi] = useState(false);
    const [isForms, setIsForms] = useState(false);
    const [isTables, setIsTables] = useState(false);
    const [isCharts, setIsCharts] = useState(false);
    const [isIcons, setIsIcons] = useState(false);
    const [isMaps, setIsMaps] = useState(false);
    const [isMultiLevel, setIsMultiLevel] = useState(false);
    const [isNotifications, setIsNotifications] = useState(false);
    const [activeInquiries, setActiveInquiries] = useState(false);

    //Campaign
    const [isCampaigns, setIsCampaigns] = useState(false);
    const [isNews, setIsNews] = useState(false);
    const [isScraper, setIsScraper] = useState(false);
    const [isTelevision, setIsTelevision] = useState(false);
    const [isNewspaper, setIsNewspaper] = useState(false);
    const [isMagazine, setIsMagazine] = useState(false);
    const [isElection2024, setIsElection2024] = useState(false);

    const [iscurrentState, setIscurrentState] = useState("Dashboard");

    const dispatch = useDispatch();
    const { campaignsWithCounts, user } = useSelector((state) => ({
        campaignsWithCounts: state.Campaign.campaignsWithCounts || [],
        user: state.Login.user,
    }));

    const localAuthUser = localStorage.getItem("authUser") ? JSON.parse(localStorage.getItem("authUser")) : null;
    const authUser = (user && user._id) ? user : localAuthUser;
    const isSuperAdmin = authUser?.role === "SuperAdmin";

    // Fetch on login (user Redux state goes from "" to object) OR on page refresh (localStorage available, campaignsWithCounts empty)
    useEffect(() => {
        if (!isSuperAdmin && user && user._id) {
            // Login case: Redux user just became available
            dispatch(getCampaignsWithCounts());
        }
    }, [user]);

    useEffect(() => {
        // Page refresh case: Redux user is empty but localStorage has user
        if (!isSuperAdmin && (!user || !user._id) && localAuthUser && localAuthUser._id && campaignsWithCounts.length === 0) {
            dispatch(getCampaignsWithCounts());
        }
    }, []);

    const [openCampaigns, setOpenCampaigns] = useState({});

    // Campaign states stored locally


    function updateIconSidebar(e) {
        if (e && e.target && e.target.getAttribute("subitems")) {
            const ul = document.getElementById("two-column-menu");
            const iconItems = ul.querySelectorAll(".nav-icon.active");
            let activeIconItems = [...iconItems];
            activeIconItems.forEach((item) => {
                item.classList.remove("active");
                var id = item.getAttribute("subitems");
                if (document.getElementById(id))
                    document.getElementById(id).classList.remove("show");
            });
        }
    }

    useEffect(() => {
        document.body.classList.remove("twocolumn-panel");
        if (iscurrentState !== "Dashboard") setIsDashboard(false);
        if (iscurrentState !== "Users") setIsUsers(false);
        if (iscurrentState !== "Inquiries") setActiveInquiries(false);
        if (iscurrentState !== "Notifications") setIsNotifications(false);
        if (iscurrentState !== "Campaigns") {
            // If another main menu is clicked, close all campaigns
            setOpenCampaigns({});
        }
        if (iscurrentState !== "News") setIsNews(false);
        if (iscurrentState !== "Scraper") setIsScraper(false);
        if (iscurrentState !== "Television") setIsTelevision(false);
        if (iscurrentState !== "Newspaper") setIsNewspaper(false);
        if (iscurrentState !== "Magazine") setIsMagazine(false);
        if (iscurrentState !== "election2024") setIsElection2024(false);
        if (iscurrentState !== "Auth") setIsAuth(false);
        if (iscurrentState !== "Pages") setIsPages(false);
        if (iscurrentState !== "BaseUi") setIsBaseUi(false);
        if (iscurrentState !== "AdvanceUi") setIsAdvanceUi(false);
        if (iscurrentState === "Widgets") {
            history("/widgets");
            document.body.classList.add("twocolumn-panel");
        }
    }, [

        history,
        iscurrentState,
        isDashboard,
        isCampaigns,
        isUsers,
        isAuth,
        isPages,
        isBaseUi,
        isAdvanceUi,
        campaignsWithCounts
    ]);

    const dynamicCampaignItems = Array.isArray(campaignsWithCounts) ? campaignsWithCounts.map(campaign => {
        const campaignState = {
            campaignId: campaign._id,
            campaignName: campaign.name || campaign.taskName,
            campaignDesc: campaign.desc,
            campaignImage: campaign.image,
            campaignStatus: campaign.status,
            campaignValidFrom: campaign.validFrom,
            campaignValidTo: campaign.validTo,
            campaignDataAnalyze: campaign.dataAnalyze, // Required for DashboardCampaign
            campaignDataAnalyzeHistory: campaign.dataAnalyzeHistory || [],
        };

        return {
            id: `campaign_${campaign._id}`,
            label: campaignState.campaignName,
            icon: "bx bx-folder",
            link: "/#",
            click: function (e) {
                e.preventDefault();
                setOpenCampaigns(prev => {
                    const nextSt = !prev[campaign._id];
                    // Close all others and toggle this one
                    let updated = {};
                    if (nextSt) updated[campaign._id] = true;
                    return updated;
                });
                setIscurrentState("Campaigns");
                updateIconSidebar(e);
            },
            stateVariables: openCampaigns[campaign._id] === true,
            subItems: [
                {
                    id: `campaign_${campaign._id}_dashboard`,
                    label: "Хянах самбар",
                    link: "/dashboard",
                    linkProps: { state: campaignState },
                    parentId: `campaign_${campaign._id}`,
                },
                {
                    id: `campaign_${campaign._id}_posts`,
                    label: "Нийтлэлүүд",
                    link: "/posts",
                    linkProps: { state: { ...campaignState, filter: 'all' } },
                    parentId: `campaign_${campaign._id}`,
                },
                {
                    id: `campaign_${campaign._id}_unread`,
                    label: "Уншаагүй",
                    link: "/posts",
                    linkProps: { state: { ...campaignState, filter: 'unread' } },
                    parentId: `campaign_${campaign._id}`,
                    badgeName: campaign.unreadCount > 0 ? campaign.unreadCount.toString() : null,
                    badgeColor: "danger"
                },
                {
                    id: `campaign_${campaign._id}_read`,
                    label: "Уншсан",
                    link: "/posts",
                    linkProps: { state: { ...campaignState, filter: 'read' } },
                    parentId: `campaign_${campaign._id}`,
                },
                {
                    id: `campaign_${campaign._id}_favorite`,
                    label: "Favorite",
                    link: "/posts",
                    linkProps: { state: { ...campaignState, filter: 'favorite' } },
                    parentId: `campaign_${campaign._id}`,
                    badgeName: campaign.favoriteCount > 0 ? campaign.favoriteCount.toString() : null,
                    badgeColor: "success"
                },
                {
                    id: `campaign_${campaign._id}_saved`,
                    label: "Хадгалсан",
                    link: "/posts",
                    linkProps: { state: { ...campaignState, filter: 'saved' } },
                    parentId: `campaign_${campaign._id}`,
                    badgeName: campaign.savedCount > 0 ? campaign.savedCount.toString() : null,
                    badgeColor: "primary"
                },
            ]
        };
    }) : [];

    const menuItems = [
        {
            label: "Үндсэн цэс",
            isHeader: true,
        },
        {
            id: "campaigns",
            label: "Нэгдсэн судалгаа",
            icon: "bx bx-layer",
            link: "/#",
            click: function (e) {
                e.preventDefault();
                setIsCampaigns(!isCampaigns);
                setIscurrentState("Campaigns");
                updateIconSidebar(e);
            },
            stateVariables: isCampaigns,
            subItems: [
                {
                    id: "campaignsControl",
                    label: "Удирдлага",
                    link: "/campaigns",
                    parentId: "campaigns",
                },
            ],
        },
        ...(!isSuperAdmin ? [
            {
                label: "Судалгааны ажлууд",
                isHeader: true,
            },
            ...dynamicCampaignItems.map(item => ({
                ...item,
                stateVariables: true
            }))
        ] : []),
        ...(isSuperAdmin ? [
            {
                id: "news",
                label: "Мэдээний веб сайт",
                icon: "bx bx-news",
                link: "/#",
                click: function (e) { e.preventDefault(); setIsNews(!isNews); setIscurrentState("News"); updateIconSidebar(e); },
                stateVariables: isNews,
                subItems: [
                    { id: "newsPosts", label: "Мэдээний веб сайтын нийтлэлүүд", link: "/news", parentId: "news" }
                ],
            },
            {
                id: "television",
                label: "Телевиз",
                icon: "bx bx-tv",
                link: "/#",
                click: function (e) { e.preventDefault(); setIsTelevision(!isTelevision); setIscurrentState("Television"); updateIconSidebar(e); },
                stateVariables: isTelevision,
                subItems: [
                    { id: "tvControl", label: "Удирдлага", link: "/tvlist", parentId: "television" },
                    { id: "tvAgenda", label: "Телевизийн хөтөлбөр", link: "/tvagenda", parentId: "television" },
                    { id: "tvNews", label: "Телевизийн мэдээ", link: "/tv", parentId: "television" }
                ],
            },
            {
                id: "newspaper",
                label: "Сонин хвлэл",
                icon: "bx bxs-news",
                link: "/#",
                click: function (e) { e.preventDefault(); setIsNewspaper(!isNewspaper); setIscurrentState("Newspaper"); updateIconSidebar(e); },
                stateVariables: isNewspaper,
                subItems: [
                    { id: "newspaperControl", label: "Удирдлага", link: "/newspaperlist", parentId: "newspaper" },
                    { id: "newspaperNews", label: "Сонин хэвлэлийн мэдээ", link: "/newspaperNews", parentId: "newspaper" }
                ],
            },
            {
                id: "magazine",
                label: "Сэтгүүл",
                icon: "bx bx-images",
                link: "/#",
                click: function (e) { e.preventDefault(); setIsMagazine(!isMagazine); setIscurrentState("Magazine"); updateIconSidebar(e); },
                stateVariables: isMagazine,
                subItems: [
                    { id: "magazineControl", label: "Удирдлага", link: "/magazinelist", parentId: "magazine" },
                    { id: "magazineNews", label: "Сэтгүүлийн мэдээ", link: "/magazineNews", parentId: "magazine" }
                ],
            },
            {
                id: "election2024",
                label: "Сонгууль 2024",
                icon: "bx bx-news",
                link: "/#",
                click: function (e) { e.preventDefault(); setIsElection2024(!isElection2024); setIscurrentState("election2024"); updateIconSidebar(e); },
                stateVariables: isElection2024,
                subItems: [
                    { id: "election2024Control", label: "Удирдлага", link: "/election2024control", parentId: "election2024" },
                    { id: "newsPosts", label: "Сонгуулийн мэдээлэл", link: "/election2024list", parentId: "election2024" }
                ],
            },
            {
                label: "Тохиргоо",
                isHeader: true,
            },
            {
                id: "scraper",
                label: "Мэдээлэл татагчийн удирдлага",
                icon: "bx bx-server",
                link: "/newslist",
                click: function (e) { setIscurrentState("Scraper"); },
                stateVariables: isScraper,
            },
            {
                id: "users",
                label: "Хэрэглэгчид",
                icon: "bx bx-user-circle",
                link: "/users",
                click: function (e) { setIscurrentState("Users"); },
                stateVariables: isUsers,
            },
            {
                id: "inquiries",
                label: "Landing Page Inquiries",
                icon: "bx bx-envelope",
                link: "/inquiries",
                click: function (e) { setIscurrentState("Inquiries"); },
                stateVariables: activeInquiries,
            },
            {
                id: "notifications",
                label: "Мэдэгдэл",
                icon: "bx bx-bell",
                link: "/notifications",
                click: function (e) { setIscurrentState("Notifications"); },
                stateVariables: isNotifications,
            }
        ] : []),
        {
            label: "Хувийн мэдээлэл",
            isHeader: true,
        },
        {
            id: "profile",
            label: "Миний профайл",
            icon: "bx bx-user-circle",
            link: "/profile",
            click: function (e) { setIscurrentState("Profile"); },
        }
    ];

    return <React.Fragment>{menuItems}</React.Fragment>;
};
export default Navdata;
